module.exports = __webpack_public_path__ + "static/media/pickup_button_grey.608cf06f.svg";